import { takeLatest } from 'redux-saga/effects';
import { put, call, fork, select } from 'redux-saga/effects';

import axios from 'axios';

// services
import ApiService from './services/ApiService';

import {  dispatchPlumbersMatch,  GET_PLUMBER_DYNAMIC_REQUEST, GET_PLUMBER_DYNAMIC, GET_PLUMBER_DYNAMIC_ERROR } from './modules/plumbers'


function* getPlumberDynamic(action) {

  try {
    const payload = action.payload
    const lat = yield select((store) => {
        return store.lat
    })
    const lng = yield select((store) => {
        return store.lng
    })
  
    const response = yield call(ApiService.setPlumberURL, lat, lng);  
  

        yield put({
            type: GET_PLUMBER_DYNAMIC,
            payload: response.data.records
        });
        yield put(dispatchPlumbersMatch(response.data.result))
     console.log(response)
    } catch ( e ) {
        yield put({
            type: GET_PLUMBER_DYNAMIC_ERROR,
            payload: e.responseText
        });
    }
}

export default function* rootSaga() {
    yield fork(takeLatest, GET_PLUMBER_DYNAMIC_REQUEST, getPlumberDynamic);
}


// WEBPACK FOOTER //
// ./src/sagas.js